import { render, staticRenderFns } from "./DistributeCreate.vue?vue&type=template&id=11e2e3fb"
import script from "./DistributeCreate.vue?vue&type=script&lang=js"
export * from "./DistributeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports